__turbopack_context__.v({
  "section": "OutputSection-module-scss-module__kovH9G__section",
  "sectionTitle": "OutputSection-module-scss-module__kovH9G__sectionTitle",
});
